<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <BreadcrumbItem
          slot="parent"
          :to="`/countries/profiles/${significant_updates.iso3}`"
          >{{ countryName }}</BreadcrumbItem
        >
        <BreadcrumbItem
          slot="parent"
          :to="`/countries/profiles/${significant_updates.iso3}`"
          >Significant Updates</BreadcrumbItem
        >
        <span slot="current">{{ isNew ? "New" : fullname }}</span>
        <span slot="title"
          >{{ isNew ? "New" : "Edit" }} Significant Updates</span
        >
        <span slot="sub-title">{{ fullname }}</span>
      </AffixHeader>

      <i-form
        ref="form"
        :model="significant_updates"
        :rules="rules"
        label-position="top"
      >
        <i-form-item label="Title" prop="title">
          <i-input type="text" v-model="significant_updates.title"></i-input>
        </i-form-item>

        <Row>
          <i-col span="12">
            <i-form-item label="Date" prop="date">
              <Date-picker
                type="date"
                :options="dateFieldOptions"
                :value="significant_updates.date"
                @on-change="
                  value => (significant_updates.date = value.toString())
                "
                style="width:100%; padding-right:6px;"
              ></Date-picker>
            </i-form-item>
          </i-col>
          <i-col span="12">
            <i-form-item
              label="Displacement Type"
              prop="displacement_type"
              style="padding-right:6px;"
            >
              <i-select
                v-model="significant_updates.displacement_type"
                filterable
              >
                <i-option value="Conflict">Conflict</i-option>
                <i-option value="Disaster">Disaster</i-option>
                <i-option value="Development">Development</i-option>
              </i-select>
            </i-form-item>
          </i-col>
        </Row>

        <i-form-item label="Source">
          <i-input v-model="significant_updates.source"></i-input>
        </i-form-item>

        <!-- Content -->
        <i-form-item label="Content">
          <i-input
            type="textarea"
            spellcheck
            :autosize="{ minRows: 6, maxRows: 36 }"
            :rows="12"
            v-model="significant_updates.content"
          ></i-input>
        </i-form-item>

        <!-- Action Buttons -->
        <i-form-item
          class="action-buttons"
          v-if="$can('manage', 'significant_updates')"
        >
          <i-button type="primary" @click="save">
            <FFIcon type="save" /> {{ isNew ? "Create" : "Update" }}
          </i-button>
        </i-form-item>
      </i-form>
    </i-col>
  </Row>
</template>

<script>
import database from "@/database";
import moment from "moment";
import { getGeoEntityByISO3 } from "@/models/GeoEntity.ts";

export default {
  props: ["id", "iso3"],

  data() {
    return {
      significant_updates: {
        title: "",
        iso3: this.iso3,
        date: "",
        displacement_type: "",
        source: "",
      },
      dateFieldOptions: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      rules: {
        title: {
          required: true,
          message: "Publication date is required",
        },
        date: {
          required: true,
          message: "Date is required",
        },
        displacement_type: {
          required: true,
          message: "Displacement type is required",
        },
      },
    };
  },

  mounted() {
    if (this.id !== null) {
      this.load();
    }
  },

  computed: {
    isNew() {
      return this.id === null;
    },
    countryName() {
      let country = getGeoEntityByISO3(this.significant_updates.iso3);
      return country.name;
    },
    fullname() {
      let date = moment(this.significant_updates.date);
      date = date.isValid() ? date.format("DD/MM/YYYY") : "...";
      return `${this.significant_updates.title} - ${this.significant_updates
        .displacement_type || "..."} ${this.countryName} ${date}`;
    },
  },

  methods: {
    load() {
      if (this.id !== null) {
        this.loading = true;
        database
          .load("significant_updates", this.id)
          .then(response => {
            this.significant_updates = response.data;
            this.loading = false;
          })
          .catch(error => {
            console.error(error);
            this.loading = false;
          });
      }
    },
    save() {
      if (!this.$can("manage", "significant_updates")) {
        this.$Message.error("User is not permitted");
        return;
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          database
            .save("significant_updates", this.significant_updates, {})
            .then(response => {
              this.significant_updates = response.data;
              this.loadingSuccess(
                this.isNew
                  ? "Significant Updates has been created"
                  : "Significant Updates has been updated"
              );
              this.$router.push(
                `/countries/significant_updates/${this.significant_updates.id}`
              );
            })
            .catch(error => {
              console.error(error.response);
              this.loadingError(
                this.isNew
                  ? "Failed to create significant updates"
                  : "Failed to update significant updates"
              );
            });
        } else {
          this.$Message.error("Form errors!");
        }
      });
    },
  },
};
</script>

<style lang="css"></style>
